import apiClient from "./client";
import { ENDPOINTS } from "./endpoints";

export const login = (email, password) => apiClient.post(ENDPOINTS.auth.login, { email, password });

export const requestMobileOtp = (countryCode, mobile) =>
  apiClient.post(ENDPOINTS.auth.loginByMobileGetOtp, { countryCode, mobile });

export const verifyMobileOtp = (countryCode, mobile, otp) =>
  apiClient.post(ENDPOINTS.auth.loginByMobileVerifyOtp, { countryCode, mobile, otp });

export const joinUs = (name, email, countryCode, mobile) =>
  apiClient.post(ENDPOINTS.auth.joinUs, { name, email, countryCode, mobile });

// forgot-password sends the reset OTP to the account's registered email
// (rem-backend/sfa-node's UserController.forgotPassword); validate-otp then
// confirms it (UserLoginController.validateEmailOtp) — there's no password
// field here, the user sets a new one from Profile after logging back in.
export const forgotPasswordSendOtp = (email) => apiClient.post(ENDPOINTS.auth.forgotPasswordSendOtp, { email });

export const forgotPasswordVerifyOtp = (email, otp) =>
  apiClient.post(ENDPOINTS.auth.forgotPasswordVerifyOtp, { email, otp });

export const logout = (userId) => apiClient.post(ENDPOINTS.auth.logout, { userId });

// Response envelope's user payload doesn't always use the same field name for
// the session token — centralize the fallback chain here instead of at each caller.
export const extractSession = (data) => {
  const payload = data?.data || data || {};
  const token = payload.token || payload.accessToken || payload.access_token || "session-" + Date.now();
  return { token, user: payload };
};
